import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';

const AppLottery = ({ siteId, mallId, customerId, disabled, liffAccessToken, ticketClick }) => {
  const [lockData, setLockData] = useState(true);
  const [lotteryResultFlag, setLotteryResultFlag] = useState([]);
  const [lotteryProcessCompletedFlag, setLotteryProcessCompletedFlag] = useState([]);
  const [customerAppLottery, setCustomerAppLottery] = useState([]);
  const [appLotteryBonus, setAppLotteryBonus] = useState([]);

  const refreshData = useCallback(async () => {
    try {
      const customerAppLotteryPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerapplottery/line/search`, { site_id: siteId, mall_id: mallId, customer_id: customerId, line_id: liffAccessToken });
      const customerAppLottery = (await customerAppLotteryPromise).data;
      const appLotteryBonusPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/line/${siteId}/${mallId}`);
      const applotterybonus = (await appLotteryBonusPromise).data;
      const rank_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/line/ranklist/`, { site_id: siteId, line_id: liffAccessToken, mall_id: mallId });
      const rank_customer_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/search/`, { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      //ランクマスタ情報を取得
      const rank_info = (await rank_info_promise).data;
      //自分のランク情報を取得
      const rank_customer_info = (await rank_customer_info_promise).data;
      const user_rank = rank_customer_info ? rank_customer_info.rank_id : rank_info[0].rank_id;
      // appLotteryBonusのapp_lottery_rankに自分のランク情報が含まれているものをフィルタリング
      const filteredAppLotteryBonus = applotterybonus.filter(lottery => 
        lottery.app_lottery_ranks.length === 0 || lottery.app_lottery_ranks.some(rank => rank.rank_id === user_rank)
      );

      const initialResultFlags = new Array(filteredAppLotteryBonus.length).fill(false);
      const initialProcessFlags = new Array(filteredAppLotteryBonus.length).fill(false);
      setCustomerAppLottery(customerAppLottery);
      setAppLotteryBonus(filteredAppLotteryBonus);

      // customerAppLotteryの各要素からlottery_idを取得し、対応するインデックスにtrueを設定
      customerAppLottery.forEach(appLottery => {
        const lotteryId = appLottery.lottery_id; // lottery_idを取得
        const lotteryIndex = appLotteryBonus.findIndex(lottery => lottery.lottery_id === lotteryId); // lottery_idに基づいてインデックスを取得

        if (lotteryIndex !== -1) {
          initialResultFlags[lotteryIndex] = true; // 該当するインデックスにtrueを設定
        }
      });

      // フラグを状態に設定
      setLotteryResultFlag(initialResultFlags);
      setLotteryProcessCompletedFlag(initialProcessFlags);
    } catch (err) {
      console.log(err);
    } finally {
      setLockData(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteId, mallId, customerId, liffAccessToken]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleStart = async (index, lotteryId) => {
    setLockData(true);
    try {
      const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerapplottery/line/lottery/`, { site_id: siteId, mall_id: mallId, lottery_id: lotteryId, line_id: liffAccessToken })).data;
      const newResultFlag = [...lotteryResultFlag];
      const newProcessFlag = [...lotteryProcessCompletedFlag];
      if (data.data && data.data.point && data.data.point.lottery && data.data.ticket && data.data.ticket.lottery) {
        newResultFlag[index] = true;
      }
      else if (data.data && data.data.point && data.data.point.lottery) {
        newResultFlag[index] = true;
      }
      else if (data.data && data.data.ticket && data.data.ticket.lottery) {
        newResultFlag[index] = true;
      }
      else {
        newResultFlag[index] = false;
      }
      const customerAppLotteryPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerapplottery/line/search`, { site_id: siteId, mall_id: mallId, customer_id: customerId, line_id: liffAccessToken });
      const customerAppLottery = (await customerAppLotteryPromise).data;
      const appLotteryBonusPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/line/${siteId}/${mallId}`);
      const applotterybonus = (await appLotteryBonusPromise).data;
      const rank_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/line/ranklist/`, { site_id: siteId, line_id: liffAccessToken, mall_id: mallId });
      const rank_customer_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/search/`, { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      //ランクマスタ情報を取得
      const rank_info = (await rank_info_promise).data;
      //自分のランク情報を取得
      const rank_customer_info = (await rank_customer_info_promise).data;
      const user_rank = rank_customer_info ? rank_customer_info.rank_id : rank_info[0].rank_id;
      // appLotteryBonusのapp_lottery_rankに自分のランク情報が含まれているものをフィルタリング
      const filteredAppLotteryBonus = applotterybonus.filter(lottery => 
        lottery.app_lottery_ranks.length === 0 || lottery.app_lottery_ranks.some(rank => rank.rank_id === user_rank)
      );
      setCustomerAppLottery(customerAppLottery);
      setAppLotteryBonus(filteredAppLotteryBonus);
      newProcessFlag[index] = true;
      setLotteryResultFlag(newResultFlag);
      setLotteryProcessCompletedFlag(newProcessFlag);
    } catch (err) {
      console.log(err);
    } finally {
      setLockData(false);
    }
  };

  return (
    lockData ? <Loading /> : (
      appLotteryBonus.length === 0 ?
        <div className="event-none-message text-center py-4 px-3 my-4 mx-auto">
          <div className="font-weight-bold mb-2">
            現在開催中のイベントはありません
          </div>
        </div>
        :
        <div className="applottery-container">
          {appLotteryBonus.map((lottery, index) => {
            const customerLottery = customerAppLottery.find(y => y.lottery_id === lottery.lottery_id) || null;

            return (
              <div className={`frame50 ${index > 0 ? 'mt-4' : ''}`} key={index}>
                {lotteryProcessCompletedFlag[index] && lotteryResultFlag[index] ? (
                  customerLottery && customerLottery.bonus_id && lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_bonus_image_url ? (
                    <img src={`/${siteId}/${constClass.LOTTERY_BONUS_IMAGE_DIR}${lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_bonus_image_url}`} alt='bonusimage' className='w-100 imground' />
                  ) : lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery?.bonus_id).bonus_type === constClass.BONUS_TYPE.BOTH ? (
                    <img src={`/${siteId}/getpointticket.svg`} alt='getpointticket' className='w-100 imground' />
                  ) : lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery?.bonus_id).bonus_type === constClass.BONUS_TYPE.POINT ? (
                    <img src={`/${siteId}/getpoint.svg`} alt='getpoint' className='w-100 imground' />
                  ) : lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery?.bonus_id).bonus_type === constClass.BONUS_TYPE.TICKET ? (
                    <img src={`/${siteId}/getticket.svg`} alt='getticket' className='w-100 imground' />
                  ) : null
                ) : lotteryProcessCompletedFlag[index] && !lotteryResultFlag[index] ? (
                  lottery.lottery_after_image_url ? (
                    <img src={`/${siteId}/${constClass.LOTTERY_AFTER_IMAGE_DIR}${lottery.lottery_after_image_url}`} alt='losing' className='w-100 imground' />
                  ) : (
                    <img src={`/${siteId}/losing.svg`} alt='losing' className='w-100 imground' />
                  )
                ) : lottery.lottery_before_image_url ? (
                  <img src={`/${siteId}/${constClass.LOTTERY_BEFORE_IMAGE_DIR}${lottery.lottery_before_image_url}`} alt='gachapon' className='w-100 imground' />
                ) : (
                  <img src={`/${siteId}/gachapon.svg`} alt='gachapon' className='w-100 imground' />
                )}

                {lotteryProcessCompletedFlag[index] && lotteryResultFlag[index] && customerLottery && lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.BOTH &&
                  <div className="applotterypointcouponframe49">
                    <div className="frame11">
                      <div className="points-held">
                        獲得ポイント
                      </div>
                      <div className="lottery-frame9">
                        <div className="lottery-points">
                          {lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).point}
                        </div>
                      </div>
                      <div className="applottery-text3">
                        {lottery && lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_message ?
                          lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_message :
                          (<>
                            おめでとうございます！<br />
                            抽選の結果、ポイントとクーポンを<br />
                            ゲットしました。
                          </>)
                        }
                      </div>
                      <button
                        disabled={disabled}
                        onClick={() => ticketClick()}
                        className="button mt-3 text-black bg-white">
                        クーポンを表示する
                      </button>
                    </div>
                  </div>
                }
                {lotteryProcessCompletedFlag[index] && lotteryResultFlag[index] && customerLottery && lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.POINT &&
                  <div className="applotterypointframe49">
                    <div className="frame11">
                      <div className="points-held">
                        獲得ポイント
                      </div>
                      <div className="lottery-frame9">
                        <div className="lottery-points">
                          {lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).point}
                        </div>
                      </div>
                      <div className="applottery-text3">
                        {lottery && lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_message ?
                          lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_message :
                          (<>
                            おめでとうございます！<br />
                            抽選の結果、ポイントをゲットしました。
                          </>)
                        }
                      </div>
                    </div>
                  </div>
                }
                {lotteryProcessCompletedFlag[index] && lotteryResultFlag[index] && customerLottery && lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.TICKET &&
                  <div className="applotterypointframe49">
                    <div className="frame11">
                      <div className="applottery-text3 my-2">
                        {lottery && lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_message ?
                          lottery.app_lottery_bonuses.find(x => x.bonus_id === customerLottery.bonus_id).lottery_message :
                          (<>
                            おめでとうございます！<br />
                            抽選の結果、クーポンをゲットしました。
                          </>)
                        }
                      </div>
                      <button
                        disabled={disabled}
                        onClick={() => ticketClick()}
                        className="button mt-3 text-black bg-white">
                        クーポンを表示する
                      </button>
                    </div>
                  </div>
                }
                {lotteryProcessCompletedFlag[index] && !lotteryResultFlag[index] &&
                  <div className="applotterypointframe49">
                    <div className="frame11">
                      <div className="applottery-text3 mt-4">
                        {lottery && lottery.lottery_fail_message ? lottery.lottery_fail_message :
                          <>残念でした・・・<br />
                            今回はポイントをゲットできませんでした。<br />
                            次回もぜひご参加ください！</>}
                      </div>
                    </div>
                  </div>
                }
                {!lotteryProcessCompletedFlag[index] &&
                  <div className="applotterypointframe49">
                    <div className="frame55">
                      <div className="frame11">
                        <div className="applottery-text1">
                          {lottery && lottery.lottery_title ? lottery.lottery_title : <>西鉄ショッピングポイントがあたる<br />抽選にチャレンジしよう！</>}
                        </div>
                        <div className="applottery-text2 mt-1">
                          {lottery && lottery.lottery_detail ? lottery.lottery_detail : <>クーポン画面で特典をご確認ください。<br /></>}
                        </div>
                        {customerAppLottery.some(appLottery => appLottery.lottery_id === lottery.lottery_id && appLottery.lottery) &&
                          <div className="text-danger mt-1 text-center align-self-center">
                            抽選済みです。
                          </div>
                        }
                        <button
                          disabled={customerAppLottery.some(appLottery => appLottery.lottery_id === lottery.lottery_id && appLottery.lottery) || disabled || lockData}
                          onClick={() => handleStart(index, lottery.lottery_id)}
                          className={`button mt-1 text-white ${customerAppLottery.some(appLottery => appLottery.lottery_id === lottery.lottery_id && appLottery.lottery) || disabled || lockData ? 'disabled' : 'bg-darkblue'}`}>
                          抽選にチャレンジする
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            );
          })}
        </div>
    )
  );
}

// {!lockData ?
//   <React.Fragment>
//     {lotteryProcessCompletedFlag && lotteryResultFlag ? (
//       <h4 className="text-black">おめでとうございます！抽選に当選しました！</h4>
//     ) : (
//       <h4 className="text-black">毎日くじを引いて、賞品をゲットしよう！</h4>
//     )}
//     <div className="frame54 d-flex flex-column justify-content-center">
//       <div className="bg-white p-4 d-flex flex-column justify-content-center">
//         <div className="align-self-center">
//           {((lotteryProcessCompletedFlag && lotteryResultFlag) || (customerAppLottery.lottery && lotteryResultFlag)) &&
//             <React.Fragment>
//               <h1 className="text-black text-center">あたり</h1>
//                <h1 className="text-black">
//               {customerAppLottery.bonus_id ? 
//                 appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.BOTH ?
//                  ticketNameList.find(x => x.ticket_id === appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).ticket_id).ticket_name +
//                  appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).point + "ポイント" :
//                   appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.POINT ?
//                   appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).point + "ポイント" :
//                   ticketNameList.find(x => x.ticket_id === appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).ticket_id).ticket_name



//                :lotteryResultData.point && lotteryResultData.ticket ?  + lotteryResultData.point.point + "ポイント" : lotteryResultData.point ? lotteryResultData.point.point + "ポイント" : ticketNameList.find(x => x.ticket_id === lotteryResultData.ticket_id).ticket_name
//               }
//               </h1>

//             </React.Fragment>
//           }
//           {((lotteryProcessCompletedFlag && !lotteryResultFlag) || (customerAppLottery.lottery && !lotteryResultFlag)) &&
//             <h1 className="text-black">はずれ</h1>
//           }
//         </div>
//         {!lotteryProcessCompletedFlag && !customerAppLottery.lottery &&
//           <div className="text-center">
//             <button
//               disabled={disabled}
//               className="button text-white bg-danger buckbutton"
//               onClick={handleStart}
//             >
//               スタート
//             </button>
//           </div>
//         }
//       </div>
//       <div className="text-left ">
//         <h4 className="text-black">毎日くじ&nbsp;概要</h4>
//         <div>
//           <div className="text-black">
//             {appLotteryBonus.m_app_lottery_bonuses && appLotteryBonus.m_app_lottery_bonuses.length > 0 && appLotteryBonus.m_app_lottery_bonuses.map((bonus, index) => (
//               <React.Fragment key={index}>
//                 <h4 className="text-black">{index + 1}等：{bonus.ticket_id ? ticketNameList.find(x => x.ticket_id === bonus.ticket_id).ticket_name + 'チケット' : ''} {bonus.point ? bonus.point + 'ポイント' : ''}</h4><br />
//               </React.Fragment>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   </React.Fragment>
//   : <Loading />}

export default AppLottery;